// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__pAcUx","loader":"Loader_loader__mwU7T"};